import React from "react";
import { Button as MuiButton, ButtonProps } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { colors } from "./colors";

interface NavigationLinkProps extends Omit<ButtonProps, "onClick"> {
  to?: string;
  onClick?: () => void;
  children: React.ReactNode;
}

const NavigationLink: React.FC<NavigationLinkProps> = ({
  to,
  onClick,
  children,
  sx,
  ...props
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (to) {
      navigate(to);
    }
  };

  return (
    <MuiButton
      {...props}
      onClick={handleClick}
      sx={{
        color: colors.text[600],
        fontFamily: "Outfit, sans-serif",
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "16px",
        letterSpacing: 0,
        textTransform: "none",
        padding: "0.5rem 1rem",
        borderRadius: "4px",
        minHeight: "44px",
        minWidth: "44px",
        "&:hover": {
          backgroundColor: "transparent",
          color: colors.neutral.white,
        },
        ...sx,
      }}
    >
      {children}
    </MuiButton>
  );
};

export default NavigationLink;
